import { StaticBaseDao } from '@/dao';
import { EventLiveStyles, StringArray } from '@/objects/generated';
import { useUserStore } from '@/stores';

export class EventLiveStyleDao extends StaticBaseDao {
    public static async GetEventLiveStyles(EventID: number): Promise<EventLiveStyles | null> {
        return this.BaseFetch(
            EventLiveStyles,
            `EventLiveStyle/GetEventLiveStyles` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
    public static async SaveEventLiveStyles(styles: EventLiveStyles, EventID: number): Promise<boolean | null> {
        return this.Post(`EventLiveStyle/SaveEventLiveStyles` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), styles);
    }
    public static async GetEventCustomScript(EventID: number): Promise<StringArray | null> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return null;
        }
        return this.BaseFetch(
            StringArray,
            `EventLiveStyle/GetEventCustomScript` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'GET',
        );
    }
    public static async SaveEventCustomScript(script: StringArray, EventID: number): Promise<boolean | null> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return null;
        }
        return this.Post(`EventLiveStyle/SaveEventCustomScript` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), script);
    }
}
